module.exports = __webpack_public_path__ + "f76ff370e58ab63539a3777a1014029c.glb";